import { createStructuredSelector } from 'reselect'

import {
  EVALUATION_MESSAGE_LIST,
  EVALUATION_MESSAGE_LIST_SUCCESS, 
  EVALUATION_MESSAGE_LIST_ERROR,
  EVALUATION_MESSAGE_PAGE_SET,
  EVALUATION_MESSAGE_SEARCH_SET,
  EVALUATION_MESSAGE_SEARCH_CHANGE,
  EVALUATION_MESSAGE_SEARCH_ASSESSMENT,
  EVALUATION_MESSAGE_SEARCH_ASSESSMENT_SUCCESS,
  EVALUATION_MESSAGE_SEARCH_ASSESSMENT_ERROR, 
  EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL,
  EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL_SUCCESS,
  EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL_ERROR, 
  EVALUATION_MESSAGE_ADD_SET,
  EVALUATION_MESSAGE_ADD_MODAL_SET,
  EVALUATION_MESSAGE_ADD,
  EVALUATION_MESSAGE_ADD_SUCCESS,
  EVALUATION_MESSAGE_ADD_ERROR,
  EVALUATION_MESSAGE_ADD_CHANGE,
  EVALUATION_MESSAGE_DETAIL,
  EVALUATION_MESSAGE_DETAIL_SUCCESS,
  EVALUATION_MESSAGE_DETAIL_ERROR,
  EVALUATION_MESSAGE_VIEW_MODAL_SET,
  EVALUATION_MESSAGE_EDIT_CHANGE,
  EVALUATION_MESSAGE_EDIT_MODAL_SET,
  EVALUATION_MESSAGE_UPDATE,
  EVALUATION_MESSAGE_UPDATE_SUCCESS,
  EVALUATION_MESSAGE_UPDATE_ERROR,
  EVALUATION_MESSAGE_VIEW_TAB_SET,
  EVALUATION_MESSAGE_UPLOAD_SET,
  EVALUATION_MESSAGE_UPLOAD_SET_SUCCESS,
  EVALUATION_MESSAGE_UPLOAD_SET_ERROR,
  EVALUATION_MESSAGE_UPLOAD_RESET
} from '../../actions';

export const NAME = 'evaluation_message';

export const EvaluationMessageList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EVALUATION_MESSAGE_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EvaluationMessageListSuccess = (data) => ({
  type: EVALUATION_MESSAGE_LIST_SUCCESS,
  payload: data
});

export const EvaluationMessageListError = (error) => ({
  type: EVALUATION_MESSAGE_LIST_ERROR,
  payload: error
});

export const EvaluationMessagePageSet = (data) => ({
  type: EVALUATION_MESSAGE_PAGE_SET,
  payload: data
});

export const EvaluationMessageSearchSet = (data) => ({
  type: EVALUATION_MESSAGE_SEARCH_SET,
  payload: data
});

export const EvaluationMessageSearchChangeSet = (data) => ({
  type: EVALUATION_MESSAGE_SEARCH_CHANGE,
  payload: data
});

export const EvaluationMessageSearchAssessment = (data) => ({
  type: EVALUATION_MESSAGE_SEARCH_ASSESSMENT,
  payload: data
});

export const EvaluationMessageSearchAssessmentSuccess = (message) => ({
  type: EVALUATION_MESSAGE_SEARCH_ASSESSMENT_SUCCESS,
  payload: message
});

export const EvaluationMessageSearchAssessmentError = (error) => ({
  type: EVALUATION_MESSAGE_SEARCH_ASSESSMENT_ERROR,
  payload: error
}); 

export const EvaluationMessageSearchEvaluationDetail = (data) => ({
  type: EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL,
  payload: data
});

export const EvaluationMessageSearchEvaluationDetailSuccess = (message) => ({
  type: EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL_SUCCESS,
  payload: message
});

export const EvaluationMessageSearchEvaluationDetailError = (error) => ({
  type: EVALUATION_MESSAGE_SEARCH_EVALUATION_DETAIL_ERROR,
  payload: error
}); 

export const EvaluationMessageAddChangeSet = (data) => ({
  type: EVALUATION_MESSAGE_ADD_CHANGE,
  payload: data
});

export const EvaluationMessageAddSet = (data) => ({
  type: EVALUATION_MESSAGE_ADD_SET,
  payload: data
});

export const EvaluationMessageAddModalSet = (data) => ({
  type: EVALUATION_MESSAGE_ADD_MODAL_SET,
  payload: data
});

export const EvaluationMessageAdd = (data) => ({
  type: EVALUATION_MESSAGE_ADD,
  payload: data
});

export const EvaluationMessageAddSuccess = (message) => ({
  type: EVALUATION_MESSAGE_ADD_SUCCESS,
  payload: message
});

export const EvaluationMessageAddError = (error) => ({
  type: EVALUATION_MESSAGE_ADD_ERROR,
  payload: error
});

export const EvaluationMessageDetail = (data) => ({
  type: EVALUATION_MESSAGE_DETAIL,
  payload: data
});

export const EvaluationMessageDetailSuccess = (data) => ({
  type: EVALUATION_MESSAGE_DETAIL_SUCCESS,
  payload: data
});

export const EvaluationMessageDetailError = (error) => ({
  type: EVALUATION_MESSAGE_DETAIL_ERROR,
  payload: error
});

export const EvaluationMessageViewModalSet = (data) => ({
  type: EVALUATION_MESSAGE_VIEW_MODAL_SET,
  payload: data
});

export const EvaluationMessageEditModalSet = (data) => ({
  type: EVALUATION_MESSAGE_EDIT_MODAL_SET,
  payload: data
});

export const EvaluationMessageEditChangeSet = (data) => ({
  type: EVALUATION_MESSAGE_EDIT_CHANGE,
  payload: data
});

export const EvaluationMessageUpdate = (data) => ({
  type: EVALUATION_MESSAGE_UPDATE,
  payload: data
});

export const EvaluationMessageUpdateSuccess = (message) => ({
  type: EVALUATION_MESSAGE_UPDATE_SUCCESS,
  payload: message.message
});

export const EvaluationMessageUpdateError = (error) => ({
  type: EVALUATION_MESSAGE_UPDATE_ERROR,
  payload: error
});

export const EvaluationMessageViewTabSet = (data) => ({
  type: EVALUATION_MESSAGE_VIEW_TAB_SET,
  payload: data
});

export const EvaluationMessageUploadSet = (file) => ({
  type: EVALUATION_MESSAGE_UPLOAD_SET,
  payload: { file },
});

export const EvaluationMessageUploadSetSuccess = (items) => ({
  type: EVALUATION_MESSAGE_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const EvaluationMessageUploadSetError = (error) => ({
  type: EVALUATION_MESSAGE_UPLOAD_SET_ERROR,
  payload: error,
});

export const EvaluationMessageUploadReset= () => ({
  type: EVALUATION_MESSAGE_UPLOAD_RESET
});

const evaluation_message = (state) => state[NAME];

export const EvaluationMessageSelector = createStructuredSelector({
  evaluation_message
})
 